import {useMutation, useQueryClient} from '@tanstack/react-query';
import giftCodeUpdaters from '@/api/updaters/giftCodes';

function useSendGiftCode() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['giftCodes', 'sendCoupon'],
    mutationFn: giftCodeUpdaters.sendCoupon,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['campaignV2Creators']});
      queryClient.invalidateQueries({queryKey: ['campaignV2CreatorsCounts']});
    },
  });
}

export default useSendGiftCode;
